<div id="scorm-complete">
    <p>Your score has been recorded, it is safe to navigate away from this page.</p>
</div>